import React, {useCallback, useEffect, useState} from "react";
import {connect, useDispatch} from "react-redux";
import {actions, Control, Form} from "react-redux-form";
import CustomSelect from "../../../components/custom-select/custom-select";
import {useTranslation} from "react-i18next";
import _ from 'lodash';
import CustomInput from "../../../components/custom-input/custom-input";
import {Button} from "@material-ui/core";
import {getRotation, putRotation} from "../../../services/rotation.service";
import {AppState} from "../../../store/store";
import {sensorList} from "../../../lists/sensors-list";
import {setDataInStore} from "../../../utils/setDataInStore";
import Loader from "react-loader-spinner";
import {getAllNames, getTemperatureNames} from "../../../services/names.service";
import {getNamesOfShadowDevice} from "../../../utils/getNameOfShadowDevice";
import LensIcon from "@material-ui/icons/Lens";

const relays = [
    {
        value: 0,
        key: 'relay1',
        label: 'Relay 1'
    },
    {
        value: 1,
        key: 'relay2',
        label: 'Relay 2'
    },
    {
        value: 2,
        key: 'relay3',
        label: 'Relay 3'
    },
    {
        value: 3,
        key: 'relay4',
        label: 'Relay 4'
    },
    {
        value: 4,
        key: 'relay5',
        label: 'Relay 5'
    }
]
const irdas = [
    {
        value: 5,
        key: 'irda1',
        label: 'Irda 1'
    },
    {
        value: 6,
        key: 'irda2',
        label: 'Irda 2'
    },
    {
        value: 7,
        key: 'irda3',
        label: 'Irda 3'
    },
    {
        value: 8,
        key: 'irda4',
        label: 'Irda 4'
    },
]

const listOfPossibleContitioner = new Array(10).fill(0);

interface RotatonProps {
    state: AppState;
}

interface IRotationRow {
    index: number;
    displaySecond: boolean;
    value1?: number;
    value2?: number;
    names: object;
}

const RotationRow: React.FC<IRotationRow> = (props) => {
    const {t} = useTranslation();
    const [firstValue, setFirstValue] = useState(0);
    const [secondValue, setSecondValue] = useState(0);
    const dispatch = useDispatch();
    useEffect(() => {
        setFirstValue(props.value1 || 0);
        dispatch(actions.change('rotation.ac' + props.index, props.value1));
    }, [props.value1])
    useEffect(() => {
        setSecondValue(props.value2 || 0);
        dispatch(actions.change('rotation.ac' + (props.index + 1), props.value2));
    }, [props.value2]);
    useEffect(() => {
        relays.map((r) => _.assign(r, {
            label: _.get(props.names, 'relays.' + r.key, r.key)
        }));
        irdas.map((r) => _.assign(r, {
            label: _.get(props.names, 'irda.' + r.key, r.key)
        }))
    }, [props.names])
    return (
        <div className='default-row'>
            <div className='default-field rotation-field'>
                <Control.select
                    model={'.ac' + props.index}
                    component={CustomSelect}
                    value={firstValue}
                    label={t( 'airConditioner') + (props.index + 1)}
                    onChange={(e) => setFirstValue(_.get(e.target, 'value'))}
                    mapProps={{
                        options: () => relays.concat(irdas),
                        id: () => {return '.ac' + props.index}
                    }}
                    id={'.ac' + props.index} />
            </div>
            {
                props.displaySecond && <div className='default-field rotation-field'>
                    <Control.select
                        model={'.ac' + (props.index + 1)}
                        component={CustomSelect}
                        value={secondValue}
                        label={t( 'airConditioner') + (props.index + 2)}
                        onChange={(e) => setSecondValue(_.get(e.target, 'value'))}
                        mapProps={{
                            options: () => relays.concat(irdas),
                            id: () => {return '.ac' + (props.index + 1)}
                        }}
                        id={'.ac' + (props.index + 1)} />
                </div>
            }
        </div>
    )
}

const RotationView: React.FC<RotatonProps> = (props) => {
    const {t} = useTranslation();
    const [loading, setLoading] = useState(true);
    const [numOfConditioner, setNumOfConditioner] = useState(0);
    const [names, setNames] = useState({});
    const [airConditionersData, setAirConditionersData] = useState([]);
    const [activeAirConditionerStatus, setActiveAirConditionerStatus] = useState(true);
    const [currentRedundancyStatus, setCurrentRedundancyStatus] = useState<boolean>(false);
    const [dissableButtons, setDissableButtons] = useState(false);
    const dispatch = useDispatch();
    useEffect(() => {
        Promise.all([getRotation(), getAllNames()])
            .then(data => {
                setDataInStore(dispatch, data[0], 'rotation');
                setCurrentRedundancyStatus(_.get(data[0], 'redundancy', false))
                setNumOfConditioner(_.get(data[0], 'numberOfAirConditioners', 0));
                setAirConditionersData(_.get(data[0], 'airConditioners', []));
                setNames(data[1]);
                setLoading(false);
            })
            .catch((err) => setLoading(false))
    }, []);

    const getListOfValuesOfAirConditioner = (rotation: any) => {
        const listOfValues = new Array(numOfConditioner).fill(0);
        Object.keys(rotation).forEach((key) => {
            if (key.includes('ac')) {
                const index = parseInt(key.replace('ac', '0'));
                if (index < numOfConditioner) {
                    const value = _.get(rotation, key) ? _.get(rotation, key) : 0;
                    listOfValues[index] = value;
                }
            }
        })
        return listOfValues;
    }
    const handleSave = () => {
        setDissableButtons(true);
        dispatch(actions.change('rotation.redundancy', false));
        const rotation = _.get(props.state, 'rotation', {});
        const airConditioners = getListOfValuesOfAirConditioner(rotation);
        const dataToSend = _.assign({}, rotation, {
            airConditioners: airConditioners,
            redundancy: false,
        });
        setCurrentRedundancyStatus(false);
        putRotation(dataToSend, []).finally(() => setTimeout(() => setDissableButtons(false), 1000))
    }
    const handleSubmit = (rotation: any) => {
        setDissableButtons(true);
        const airConditioners = getListOfValuesOfAirConditioner(rotation);
        const dataToSend = _.assign({}, rotation, {
            airConditioners: airConditioners,
            redundancy: !currentRedundancyStatus
        });
        const names = !currentRedundancyStatus ? getNamesOfShadowDevice(airConditioners) : [];
        setCurrentRedundancyStatus(!currentRedundancyStatus);
        putRotation(dataToSend, names).finally(() => setTimeout(() => setDissableButtons(false), 1000))
    }
    if (loading) {
        return <div className='w-100 d-flex justify-content-center pt-5'>
            <Loader
                type="Puff"
                color="#555374"
                height={100}
                width={100}
                timeout={3000} //3 secs

            /></div>
    }

    const handleSetNumberOfAirConditioners = (num: number) => {
        setActiveAirConditionerStatus(false);
        setNumOfConditioner(num);
        dispatch(actions.change('rotation.numberOfActiveAirConditioner', 0));
        setTimeout(() => setActiveAirConditionerStatus(true), 500);
    }

    const renderNumberOfActiveConditioner = () => {
        return (
            <Control.select
                model='.numberOfActiveAirConditioner'
                component={CustomSelect}
                label={t( 'redundancy.numberOfActiveAirConditioner')}
                mapProps={{
                    options: () => new Array(numOfConditioner + 1).fill(0).map((item, index) => {
                        return {
                            value: index,
                            label: index
                        }
                    }),
                    id: () => '.numberOfActiveAirConditioner'
                }}
                id={'.numberOfActiveAirConditioner'} />
        )
    }

    const getNumberOfRows = () => {
        return new Array(Math.floor(numOfConditioner/2)).fill(0);
    }

    const isEven = (value: number) => {
        return (value % 2) === 0;
    }
    return (
        <div className='d-flex justify-content-center w-100 align-items-start mt-1'>
            <div className='card default-card rotation-card'>
                <div className="card-body">
                    <Form
                        model='rotation'
                        onSubmit={(rotation) => handleSubmit(rotation)}>
                        <div>
                        <div className="d-flex justify-content-center">
                                    <span className=''>{currentRedundancyStatus ? t('active') :  t('notactive')}</span>
                                    <LensIcon className={currentRedundancyStatus ? 'ml-2 greenLens' : 'ml-2 redLens'}/>
                                </div>
                                <div className='card-title-container'>
                                <div className='card-title-with-icon'>
                                <span className='card-title'>{t('rotation')}</span>
                            </div>
                                </div>
                            
                        </div>
                        <div className='default-row'>
                            <div className='default-field rotation-field'>
                                <Control.select
                                    model='.numberOfAirConditioners'
                                    component={CustomSelect}
                                    value={numOfConditioner}
                                    label={t( 'redundancy.numberOfAirConditioners')}
                                    onChange={e => handleSetNumberOfAirConditioners(_.get(e, 'target.value', 0))}
                                    mapProps={{
                                        options: () => listOfPossibleContitioner.map((item, index) => {
                                            return {
                                                value: index,
                                                label: index
                                            }
                                        }),
                                        id: () => '.numberOfAirConditioners'
                                    }}
                                    id={'.numberOfAirConditioners'} />
                            </div>
                            <div className='default-field rotation-field'>
                                {activeAirConditionerStatus && renderNumberOfActiveConditioner()}
                            </div>
                        </div>
                        <div className='default-row'>
                            <div className='default-field rotation-field'>
                                <Control
                                    model={".startRedundancy"}
                                    component={CustomInput}
                                    label={t('redundancy.startRedundancy')}
                                    id={'.startRedundancy'} />
                            </div>
                            <div className='default-field rotation-field'>
                                <Control
                                    model={".cycleRedundancy"}
                                    component={CustomInput}
                                    label={t('redundancy.cycleRedundancy')}
                                    id={'.cycleRedundancy'} />
                            </div>
                        </div>
                        <div className='default-row'>
                            <div className='default-field rotation-field'>
                                <Control
                                    model={".upTempThreash"}
                                    component={CustomInput}
                                    label={t('redundancy.upTempThreash')}
                                    id={'.upTempThreash'} />
                            </div>
                            <div className='default-field rotation-field'>
                                <Control
                                    model={".downTempThreash"}
                                    component={CustomInput}
                                    label={t('redundancy.downTempThreash')}
                                    id={'.downTempThreash'} />
                            </div>
                        </div>
                        <div className='default-row'>
                            <div className='default-field rotation-field'>
                                <Control.select
                                    model='.sensor'
                                    component={CustomSelect}
                                    label={t('sensorInRotation')}
                                    mapProps={{
                                        options: () => sensorList.map((sensor) => {
                                            return {
                                                value: sensor.value,
                                                label: _.get(names, 'temperature.' + sensor.key)
                                            }
                                        }),
                                        id: () => '.redundancyMode'
                                    }}
                                    id={'.redundancyMode'} />
                            </div>
                        </div>
                        {
                            getNumberOfRows().map((item, index) => <RotationRow names={names} value1={airConditionersData[index * 2]} value2={airConditionersData[(index * 2) + 1]} index={index * 2} displaySecond={true}/>)
                        }
                        {
                            !isEven(numOfConditioner) && <RotationRow names={names} value1={airConditionersData[numOfConditioner - 1]} index={numOfConditioner - 1} displaySecond={false}/>
                        }

                        <div className='modal-action-row'>
                            <Button variant="outlined" disabled={dissableButtons} type='button' onClick={handleSave} color="primary" className='modal-default-button'>
                                {t('save')}
                            </Button>
                            <Button variant="contained" disabled={dissableButtons} type='submit' color="primary" className='modal-default-button'>
                                { !currentRedundancyStatus ? t('activate') : t('deactivate') }
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: AppState) => ({
    state: state
});
export default connect(mapStateToProps)(RotationView);